module.exports = __webpack_public_path__ + "static/img/pro1.51f23190.jpg";